import memoize from 'fast-memoize';

/**
 * Returns the part of the number based on the length provided
 * @param num number that needs to be splitted
 * @param length substr length
 * @returns splitted number
 */
export const lastDigits = memoize((num: number | string, length: number) => {
    const numStr = num?.toString();
    return numStr?.slice(numStr.length - length);
});
